/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetUserAddressesClientResponse } from '../models/GetUserAddressesClientResponse';
import type { Pagination1OfUserAddressAdminDto } from '../models/Pagination1OfUserAddressAdminDto';
import type { PostUserAddressRequestClient } from '../models/PostUserAddressRequestClient';
import type { PutUserAddressAdminRequest } from '../models/PutUserAddressAdminRequest';
import type { PutUserAddressRequestClient } from '../models/PutUserAddressRequestClient';
import type { UserAddressAdminDto } from '../models/UserAddressAdminDto';
import type { UserAddressClientDto } from '../models/UserAddressClientDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserAddressesService {
    /**
     * @returns UserAddressClientDto OK
     * @throws ApiError
     */
    public static postUserAddressClient({
        requestBody,
    }: {
        requestBody?: PostUserAddressRequestClient,
    }): CancelablePromise<UserAddressClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/useraddresses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserAddressesClientResponse OK
     * @throws ApiError
     */
    public static getUserAddressesClient({
        regionId,
    }: {
        regionId?: number,
    }): CancelablePromise<GetUserAddressesClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/useraddresses',
            query: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserAddressClientDto OK
     * @throws ApiError
     */
    public static putUserAddressClient({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutUserAddressRequestClient,
    }): CancelablePromise<UserAddressClientDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/client/v1/useraddresses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteUserAddressClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/client/v1/useraddresses/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewUserAddress`
     * @returns Pagination1OfUserAddressAdminDto OK
     * @throws ApiError
     */
    public static getUserAddressesAdmin({
        regionId,
        userId,
        page,
        limit,
    }: {
        regionId?: number,
        userId?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfUserAddressAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/useraddresses',
            query: {
                'regionId': regionId,
                'userId': userId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserAddress`
     * @returns UserAddressAdminDto OK
     * @throws ApiError
     */
    public static putUserAddressAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutUserAddressAdminRequest,
    }): CancelablePromise<UserAddressAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/useraddresses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageUserAddress`
     * @returns any OK
     * @throws ApiError
     */
    public static updateMissingLocationNamesAdmin(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/useraddresses/update-missing-location-names',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
